import * as React from 'react';
import { Box, Grid, Link } from '@material-ui/core';
import { Link as BrowserLink } from 'react-router-dom';
import styled from 'styled-components';

const StyledLink = styled(BrowserLink)`
    color: #1d57c7;
`;

const StyledLinkA = styled.a`
    color: #1d57c7;
`;

export const RightFooter: React.FC = () => {
    return (
        <Box display={'flex'} flexDirection={'column'} justifyContent={'space-between'}>
            <Grid container spacing={4}>
                <Grid item xs={6}>
                    <Box fontSize={'16px'} pb={1} fontWeight={'bold'} color="secondary.main">
                        Quick links
                    </Box>
                    <Box py={1} fontSize={'14px'} color="secondary.main">
                        <div style={{ lineHeight: '26px' }}>
                            <StyledLink to={'/'}>Appstore home</StyledLink>
                        </div>
                        <div style={{ lineHeight: '26px' }}>
                            <StyledLinkA
                                href={'https://www.bokun.io/privacy-policy'}
                                target={'_blank'}
                            >
                                Privacy policy
                            </StyledLinkA>
                        </div>
                        <div style={{ lineHeight: '26px' }}>
                            <StyledLink to={'/developer'}>Developers</StyledLink>
                        </div>
                        <div style={{ lineHeight: '26px' }}>
                            <Link href="https://bokun.dev" target="_blank">
                                Developer documentation
                            </Link>
                        </div>
                        <div style={{ lineHeight: '26px' }}>
                            <Link href="https://www.bokun.io/legal/api-terms" target="_blank">
                                App store terms
                            </Link>
                        </div>
                    </Box>
                </Grid>
                <Grid item xs={6}>
                    <Box fontSize={'16px'} pb={1} fontWeight={'bold'} color="secondary.main">
                        Contact us
                    </Box>
                    <Box py={1} fontSize={'14px'} color="secondary.main">
                        <Link href="mailto:support@bokun.is" target="_blank">
                            support@bokun.is
                        </Link>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};
